import { render, staticRenderFns } from "./ExhibitionsContent.vue?vue&type=template&id=033e3b03&"
import script from "./ExhibitionsContent.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsContent.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports